// FilterableTypes
export const FilterableTypes = {
  Equals: 'Equals',
  Contains: 'Contains',
  StartsWith: 'StartsWith',
  EndsWith: 'EndsWith',
  LessThan: 'LessThan',
  LessThanOrEqual: 'LessThanOrEqual',
  GreaterThan: 'GreaterThan',
  GreaterThanOrEqual: 'GreaterThanOrEqual',
  Null: 'Null',
  NotNull: 'NotNull',
} as const;

export type FilterableType = (typeof FilterableTypes)[keyof typeof FilterableTypes];
